// extracted by mini-css-extract-plugin
export default {"mapArea":"jut__MapArea_DEPRECATED__mapArea"};